import { AppConfig, Environment } from '../app/models/app.model';

export const domains = ['localhost', '127.0.0.1'];
export const href = 'https://localhost:57197';

export const config: AppConfig = {
  apiGateway: 'https://localhost:57197',
  env: Environment.LOCAL,
  appName: 'Swisscom Sign (Local)',
};
